import Hero from "./components/Hero";
import Introduction from "./components/Introduction";
import ProcessSteps from "./components/ProcessSteps";
import Gallery from "./components/Gallery";
import CTA from "./components/CTA";

export default function WoodMold() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Introduction />
      <ProcessSteps />
      <Gallery />
      <CTA />
    </div>
  );
}
